import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useTranslation } from "react-i18next";
import formatDate from "../../../utilities/formatDate";

const InfoDialog = ({ open, close, event }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={close} fullWidth>
      <DialogTitle sx={{ pb: 1 }}>{event?.name}</DialogTitle>
      <Divider />
      <DialogContent>
        <Typography
          variant="overline"
          color="text.secondary"
          display="block"
          sx={{ mb: 1.5 }}
        >
          Event Details
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
            <CalendarTodayIcon fontSize="small" color="action" sx={{ mt: "2px" }} />
            <Typography variant="body2">
              {event?.start ? formatDate(event?.start) : formatDate(event?.date)}
            </Typography>
          </Box>

          {event?.venueName && (
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
              <LocationOnIcon fontSize="small" color="action" sx={{ mt: "2px" }} />
              <Box>
                <Typography variant="body2">{event.venueName}</Typography>
                {event?.venueAddress1 && (
                  <Typography
                    variant="body2"
                    color="primary"
                    component="a"
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      `${event.venueAddress1}${event.venueCity ? `, ${event.venueCity}` : ""}`
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                    sx={{ textDecoration: "underline", cursor: "pointer" }}
                  >
                    {event.venueAddress1}{event.venueCity ? `, ${event.venueCity}` : ""}
                  </Typography>
                )}
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>{t("dialog.gotit.button")}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoDialog;
